/**
 * Number of equal-width grid columns for a strip of `count` labels in a container `containerWidth` px wide, where a label may not
 * be narrower than `minCellWidth` px and columns are `gap` px apart.
 *
 * Rows are balanced: first work out how many rows are unavoidable at the minimum width, then spread the labels evenly over them —
 * 7 labels that fit 6 per row become 4 + 3, not 6 + 1.
 */
export const balancedLabelColumns = (count: number, containerWidth: number, minCellWidth: number, gap = 0): number => {
  if (count <= 0) return 1;
  const perRow = Math.max(1, Math.floor((containerWidth + gap) / (minCellWidth + gap)));
  const rows = Math.ceil(count / perRow);
  return Math.ceil(count / rows);
};
